// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3wF3p","label":"styles_label__3Fogm","input":"styles_input__3MQ5O"};